// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__tRsiJ","red":"Logo_red__B75-J"};